// extracted by mini-css-extract-plugin
module.exports = {"plot":"index-module__plot___3x3qi","rankTable":"index-module__rankTable___1Z4tU"};